<div class="site-loader" [hidden]="!loading">
    <div>{{ 'common.loading' | translate }}</div>
</div>
